export default __webpack_public_path__ + "static/media/190629_190332_IMG_3625.15d00ce7.jpg";